export default __webpack_public_path__ + "5aad6b73525dd70ed14e63a041574b25.svg";